/**
 * @generated SignedSource<<bd6d52dd54142c35ff4cc9f64287a8ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LeadCell$data = {
  readonly lead: {
    readonly " $fragmentSpreads": FragmentRefs<"UserProfile">;
  } | null | undefined;
  readonly " $fragmentType": "LeadCell";
};
export type LeadCell$key = {
  readonly " $data"?: LeadCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"LeadCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "LeadCell",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "lead",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "UserProfile"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "f09d1fda14f8eccf8a3c26df20c2ae4d";

export default node;
